// 密码输入框
<template>
  <urs-input
  ref="input"
  :name="name"
  :placeholder="placeholder"
  :disabled="disabled"
  :type="type"
  :del_icon_clazz="del_icon_clazz"
  @focus="onFocus"
  @delete="onDelete"
  >
  <i slot="icon-button" v-if="needEye" :class="showPass?eye_open_icon_clazz:eye_close_icon_clazz" @click="onEye">
    <svg
        class="icon "
        aria-hidden="true"
      >
        <use :xlink:href="showPass?eye_open_icontype:eye_close_icontype" />
      </svg>
  </i>
  </urs-input>
</template>

<script>
export default {
  name: 'urs-pwdinput',
  props: {
    name: String,
    placeholder: String,
    disabled: Boolean,
    eye_open_icontype:{
      type: String,
      default: '#icon-ic-openEye'
    },
    eye_close_icontype:{
      type: String,
      default: '#icon-ic-closeEye'
    },
    del_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-delete'
    },
    eye_open_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-password-cipher'
    },
    eye_close_icon_clazz: {
      type: String,
      default:'i-icon i-icon-password-clear'
    },
    size: {
      type: String,
      default: 'large'
    },
    needEye: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      showPass: false,
      type: 'password'
    }
  },
  watch: {
    showPass(val) {
      this.type = val===true?'text':'password'
    }
  },
  methods: {
    onEye (event) {
      this.showPass = !this.showPass;
    },
    validate (){
      let val = this.$refs.input.currentValue,msg={
          errorMsg:'',
          status:true
        };;
      if(val === ''){
        // window.showError('请输入密码')
        // return false;
        msg.errorMsg="请输入密码";
        msg.status=false;
      }
      return msg;
    },
    getValue() {
      return this.$refs.input.currentValue;
    },
    onFocus(){
        var parent = this.$parent;
        if(parent.$options.name=='form-item'){
            parent.setMsg('');
            this.$emit('focus');
        }
    },
    onDelete(){
      this.$emit('delete');
    },
    focusInput(){
      this.$refs.input.focus();
    }
  }
}
</script>




// WEBPACK FOOTER //
// Pwdinput.vue?256f7662